<ng-container *ngIf="canInit">
  <div *ngIf="editorContent" [class.deny]="disabled"
  [froalaEditor]='options' [(froalaModel)]="editorContent"
  #froalaEditor></div>
</ng-container>
